import { useState } from 'react'
import { FieldArray, FormikProvider, useFormik } from 'formik'
import { colors, ModalForm } from 'modules/app/styles'
import { FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap'
import { CurrentPlanInfo, PlanSelector, PriceLabel, ManagePlanActionButtons, Divider } from './styles'
import * as yup from 'yup'
import { deleteCompanyMember_api, inviteUsers_api } from 'store/apis'
import { checkIsOnGracePeriod, getDiscountedPrice, handleApiError, logAmplitudeEvent } from 'utils/helpers'
import { toast } from 'react-toastify'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { ReactComponent as BackIcon } from 'assets/images/icons/back.svg'
import { ReactComponent as AddUsers } from 'assets/images/icons/Add_users.svg'
import { RemoveInviteEmail } from 'modules/settings/styles'
import { ReactComponent as TrashIcon } from 'assets/images/icons/trash_2.svg'
import { CustomButton } from 'modules/auth/styles'
import { ReactComponent as ManagePlanIllustrator } from 'assets/images/manage_plan_illustration.svg'
import ReactSwitch from 'react-switch'
import moment from 'moment'
import { ButtonLoader } from 'utils/storageUtils'
import { connect } from 'react-redux'
import { getActiveSubscription_action, toggleCardModal_action, toggleCheckoutModal_action } from 'store/actions'

const Checkout = (props) => {
  const [showInviteMessage, setShowInviteMessage] = useState(false)
  const checkoutForm = useFormik({
    enableReinitialize: true,
    validateOnBlur: false,
    initialValues: {
      members: props.active_users.map((u) => ({ member_code: u.member_code, name: u.name, email: u.email, user_type: u.user_type, position: u.position, id: u.id })),
      invite_message: `${props.user.name} is inviting you to join their party!\nVenue: ${props.company.name} Klutch Base.\nJoin now and never miss a beat. Stay updated with everything ${props.company.name} by joining their Base now.`
    },
    validationSchema: yup.object().shape({
      members: yup.array().of(
        yup.object().shape({
          email: yup.string().email('Invalid Email').required('Required'),
          user_type: yup.string().required()
        })
      )
    }),
    onSubmit: async (fields) => {
      try {
        if (checkoutForm.values.members.filter((m) => !m.id).length > 0) {
          const data = { ...fields, members: JSON.stringify(fields.members.filter((u) => !u.id)) }
          const response = await inviteUsers_api(data)
          logAmplitudeEvent('Invited teammates', { members: fields.members })
          toast.success(response.message)
          if (props.is_subscribed && props.subscription.plan.interval === props.plan_selected.interval) {
            props.toggleCheckoutModal(false)
            return
          }
        }
        if (!props.card.id) {
          props.toggleCardModal(true)
        } else {
          props.startSubscription()
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  })
  // Delete Member
  const onDeleteMember = async (member) => {
    if (window.confirm('Are you sure you want to remove this member?')) {
      try {
        await deleteCompanyMember_api(member.member_code)
        toast.success('Member removed.')
        props.get_company()
        props.getActiveSubscription()
      } catch (error) {
        handleApiError(error)
      }
    }
  }
  const getNextInvoiceAmount = () => {
    let final_amount = checkoutForm.values.members.length * (props.plan_selected.amount / 100)
    if (checkIsOnGracePeriod(props.isOnGracePeriod, props.subscription)) {
      final_amount = final_amount - final_amount * 0.2
    }
    return final_amount
  }
  const getNextInvoiceDate = () => {
    return moment().add(1, props.plan_selected.interval).format('ll')
  }
console.log(props.company.country, 'props');
  return (
    <Modal size='lg' isOpen={true} fade={false} centered toggle={() => props.toggleCheckoutModal(false)}>
      <ModalBody className='p-0'>
        <a
          href='/'
          className='modal-close'
          onClick={(e) => {
            e.preventDefault()
            props.toggleCheckoutModal(false)
          }}>
          <CloseIcon />
        </a>
        <ModalForm className='h-100 d-flex flex-wrap flex-md-nowrap' onSubmit={checkoutForm.handleSubmit} autoComplete='off'>
          <div className='pb-0 d-block d-md-none' style={{ padding: 24 }}>
            <div className='title d-flex align-items-center justify-content-between mb-5'>
              <span>{props.is_subscribed ? 'Manage Plan' : 'Start PRO Plan'}</span>
            </div>
          </div>
          <CurrentPlanInfo className='p-0'>
            <div className='pb-0 d-none d-md-block' style={{ padding: 24 }}>
              <div className='title d-flex align-items-center justify-content-between mb-5'>
                <span>{props.is_subscribed ? 'Manage Plan' : 'Start PRO Plan'}</span>
              </div>
            </div>
            <FormikProvider value={checkoutForm}>
              <FieldArray
                name='members'
                render={(arrayhelpers) => (
                  <>
                    <div className='members-list'>
                      {checkoutForm.values['members'].map((member, index) => (
                        <div key={index} className='d-flex align-items-center mb-3 mx-0'>
                          <FormGroup>
                            <Input
                              type='text'
                              id={`email_${index}`}
                              name={`members.${index}.email`}
                              onChange={(e) => !member.id && checkoutForm.handleChange(e)}
                              value={member.email}
                              autoFocus
                              className={`invite-member ${member.email ? 'has-value' : ''} ${
                                checkoutForm.touched.members &&
                                checkoutForm.touched.members[index] &&
                                checkoutForm.touched.members[index].email &&
                                checkoutForm.errors.members &&
                                checkoutForm.errors.members[index] &&
                                checkoutForm.errors.members[index].email
                                  ? 'error'
                                  : ''
                              }`}
                              disabled={member.id}
                            />
                            <Label className='text-secondary' htmlFor={`email_${index}`}>
                              Email
                            </Label>
                            {checkoutForm.values.members.length > 1 && (
                              <RemoveInviteEmail
                                href='/'
                                onClick={(e) => {
                                  e.preventDefault()
                                  if (member.id) {
                                    onDeleteMember(member)
                                  } else {
                                    arrayhelpers.remove(index)
                                  }
                                }}>
                                <TrashIcon />
                              </RemoveInviteEmail>
                            )}
                            {/* <ErrorMessage name={`members.${index}.email`} className='error-message' component='div' /> */}
                          </FormGroup>

                          <FormGroup className='ml-2 ml-md-4 d-flex align-items-start'>
                            <Input
                              type='select'
                              name={`members.${index}.user_type`}
                              value={checkoutForm.values.members[index].user_type}
                              disabled={member.id}
                              onChange={(e) => checkoutForm.setFieldValue(`members.${index}.user_type`, e.target.value)}>
                              <option value='admin'>Admin</option>
                              <option value='member'>Member</option>
                            </Input>
                          </FormGroup>
                        </div>
                      ))}
                    </div>
                    <ManagePlanActionButtons className={showInviteMessage ? 'show-invite-message' : ''}>
                      <div className='d-flex align-items-center flex-wrap flex-sm-nowrap'>
                        <CustomButton
                          type='button'
                          className='gray btn-sm shadow-none d-flex align-items-center mx-auto mx-sm-0'
                          disabled={!checkoutForm.isValid}
                          onClick={() => {
                            arrayhelpers.insert(checkoutForm.values.members.length, { name: '', email: '', user_type: 'member', position: '' })
                          }}>
                          <span className='mr-1'>
                            <AddUsers />
                          </span>
                          <span style={{ fontSize: props.plan_selected.interval === 'month' ? 14 : props.isOnGracePeriod ? 12 : 14 }}>
                            New User for ${getDiscountedPrice(props.plan_selected, props.isOnGracePeriod, props.subscription)}/{props.plan_selected.interval === 'month' ? 'mo.' : 'yr.'}
                          </span>
                        </CustomButton>
                        <a
                          href='/'
                          className='ml-sm-3 invite-message'
                          onClick={(e) => {
                            e.preventDefault()
                            setShowInviteMessage((value) => !value)
                          }}>
                          <span>Invite Message</span>
                          <span className={`arrow-icon ${showInviteMessage ? 'open' : ''}`}>
                            <BackIcon />
                          </span>
                        </a>
                        {props.is_subscribed && props.set_showConfirmCancelSubscription && (
                          <>
                            <Divider style={{ margin: '0 12px' }}></Divider>
                            <a
                              href='/'
                              className='text-danger'
                              onClick={(e) => {
                                e.preventDefault()
                                props.set_showConfirmCancelSubscription(true)
                              }}>
                              Move to Free
                            </a>
                          </>
                        )}
                      </div>
                      <div className='invite_message'>
                        <Input
                          type='textarea'
                          rows={4}
                          name='invite_message'
                          onChange={checkoutForm.handleChange}
                          value={checkoutForm.values.invite_message}
                          placeholder='Write your custom message here'
                        />
                      </div>
                    </ManagePlanActionButtons>
                  </>
                )}
              />
            </FormikProvider>
          </CurrentPlanInfo>
          <PlanSelector className={`checkout ${props.is_subscribed ? 'px-4' : ''}`}>
            <div className='checkout-illustrator mt-4'>
              <ManagePlanIllustrator />
            </div>
            <div className='plan-amount mb-2'>
              $<span className='amount'>{getNextInvoiceAmount()}</span>
              <span className='interval'>/{props.plan_selected.interval === 'month' ? 'mo.' : 'yr.'}</span>
              {props.company?.country == 'IL' && (<span className='interval'><i>{'+Tax'}</i></span>)}
            </div>
            <div className='user-count mb-3'>
              Current {checkoutForm.values.members.length} {checkoutForm.values.members.length === 1 ? 'user' : 'users'}
            </div>
            <div className='mb-5 d-flex align-items-center justify-content-center'>
              <PriceLabel className={`text-right ${props.plan_selected.interval === 'month' ? 'active' : ''}`} onClick={() => props.set_plan_selected(props.monthly)}>
                Monthly
              </PriceLabel>
              <ReactSwitch
                id='pricing_plan'
                onChange={(status) => props.set_plan_selected(status ? props.yearly : props.monthly)}
                checked={props.plan_selected.interval === 'year'}
                className={`reactSwitch mx-2 ${props.plan_selected.interval === 'year' ? 'on' : 'off'}`}
                offColor='#fff'
                onColor={colors['main-blue']}
                offHandleColor={colors['light-blue-300']}
                onHandleColor='#fff'
                width={48}
                height={24}
                handleDiameter={18}
                uncheckedIcon={false}
                checkedIcon={false}
              />
              <PriceLabel className={props.plan_selected.interval === 'year' ? 'active' : ''} onClick={() => props.set_plan_selected(props.yearly)}>
                Yearly <small>(save 20%)</small>
              </PriceLabel>
            </div>
            <ul className='mt-auto px-4 mx-3 mx-sm-0' style={{ listStyleType: 'disc' }}>
              <li>
                You added {checkoutForm.values.members.filter((m) => !m.id).length} additional user(s), bringing you to a total of {checkoutForm.values.members.length} user(s) on the{' '}
                {props.plan_selected.interval}ly plan.
              </li>
              {!props.is_subscribed && <li>You will be charged ${getNextInvoiceAmount()} today.</li>}
              <li>You will be charged ${getDiscountedPrice(props.plan_selected, props.isOnGracePeriod, props.subscription)} each time the new invitee accepts the invitation.</li>
              <li>Your next payment will be due on {getNextInvoiceDate()}</li>
            </ul>
            <div className='d-flex mt-4'>
              <CustomButton type='button' className='black px-3 mr-3' disabled={props.isSubmittingSubscription || props.isSubmittingCard} onClick={() => checkoutForm.submitForm()}>
                {props.is_subscribed ? 'Save changes' : 'Start subscription'} {props.isSubmittingSubscription && <ButtonLoader />}
              </CustomButton>
              {props.is_subscribed && (
                <CustomButton type='button' className='gray px-3 shadow-none' disabled={props.isSubmittingSubscription || props.isSubmittingCard} onClick={() => props.toggleCheckoutModal(false)}>
                  Cancel
                </CustomButton>
              )}
            </div>
          </PlanSelector>
        </ModalForm>
      </ModalBody>
    </Modal>
  )
}
const mapStateToProps = (state) => ({
  user: state.auth.user,
  company: state.company.company,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isSubmittingSubscription: state.subscription.isSubmittingSubscription,
  isSubmittingCard: state.subscription.isSubmittingCard,
  is_subscribed: state.subscription.is_subscribed,
  subscription: state.subscription.subscription
})

const mapDispatchToProps = (dispatch) => ({
  getActiveSubscription: () => dispatch(getActiveSubscription_action()),
  toggleCheckoutModal: (value) => dispatch(toggleCheckoutModal_action(value)),
  toggleCardModal: (value) => dispatch(toggleCardModal_action(value))
})

export default connect(mapStateToProps, mapDispatchToProps)(Checkout)
